import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    

   

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Faculty Recruitment" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Faculty Recruitment</h1>
                    </div>

                    <Row>
                        <div
                            className="col-lg-12 col-md-12  wow fadeInUp animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            <div
                                className="faq-wrap pl-30 wow fadeInUp animated"
                                data-animation="fadeInUp"
                                data-delay=".4s"
                            >
                                <div
                                    className="accordion"
                                    id="accordionExample"
                                >

                                        {/* Index11 ---------------------- start */}
                                   
                                       {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                    className={`faq-btn${activeIndex === 2 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse11`}
                                                    onClick={() =>
                                                        handleToggle(11)
                                                    }
                                                >
                                                    
                                                        <h3> Rolling Advertisement for Faculty Positions in Computer Science Engineering</h3>
                                                        <h4> Rolling Advertisement No. IITT/FACREC/01/2025 dated: May 23, 2025</h4>
                                                    
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse11`}
                                            className={`collapse${activeIndex === 2 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">

                                                <b className="c-link glowing-text">Update : The cutoff date for the current round of the Rolling Advertisement is 15th September 2025. Candidates who successfully complete their applications by this date will be considered for this round of recruitment. The tentative interview schedule is planned for the second week of October 2025.</b>
<br /><br />
                                                <b>
                                                IIT Tirupati invites applications for regular faculty positions at the levels of Assistant Professor, Associate Professor, and Professor in the Department of Computer Science and Engineering and the research areas as indicated below:  
                                                <br /><br />
                                                Artificial Intelligence and Machine Learning, Computer Vision, Security, Natural Language Processing, Speech Processing, Architecture, Algorithms, Compilers, Operating Systems, Databases, Formal Verification, Networks, Programming Languages, Software Engineering, Human-Computer Interaction.
                                                </b>

                                                <ul className="myulcustarrow mt-3">
                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2025/Faculty_Rolling_Advertisement_No_IITTFACREC012025_CSE.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">Detailed Advertisement</b>
                                                             
                                                        </Link>
                                                    </li>
                                                    
                                                     <li>
                                                        <Link
                                                            to="https://iittp.plumerp.co.in/prod/iittirupati/facultyrecruitment"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online
                                                            </b>
                                                        </Link>
                                                    </li> 
                                                     <li>
                                                        <b>
                                                            Starting Date of Online Application - 24.01.2024
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of Online Application - 29.02.2024
                                                        </b>
                                                    </li> 

                                                </ul>
                                            </div>
                                            <p class="caboutus"><b><em>Note: *This is a rolling advertisement; hence, there is no closing date. Interviews will be conducted twice a year based on the number of applications received".</em></b></p>
                                        </div>
                                    </div> */}
                                    
                                     {/* Index11 ---------------------- End  */}

                                    {/* Index11 ---------------------- start */}

                                    <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                    className={`faq-btn${activeIndex === 12 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse11`}
                                                    onClick={() =>
                                                        handleToggle(12)
                                                    }
                                                >
                                                    
                                                        <h3> Faculty Recruitment Advertisement – 2026 </h3>
                                                        <h4> Advertisement No. IITT/FACREC/01/2026 dated 10-04-2026</h4>
                                                    
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse12`}
                                            className={`collapse${activeIndex === 12 ? ' show' : ' hide'}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                    

                                               <b style={{ color: "blue" }}>
                                                     Indian Institute of Technology Tirupati invites applications from eligible candidates with a strong research background and commitment to teaching for faculty positions at the levels of Assistant Professor, Associate Professor, and Professor.
                                                </b>

                                               

                                                <ul className="myulcustarrow mt-3">
                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2026/IITTFACREC012026_Fac_Rec.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link glowing-text">Detailed Advertisement (English Version)</b>
                                                        </Link>
                                                    </li>                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2026/IITTFACREC012026_Fac_Rec_hindi.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link glowing-text">Detailed Advertisement (Hindi Version)</b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://iittp.plumerp.co.in/prod/iittirupati/facultyactiveadv"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link glowing-text">
                                                                Apply Online 
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of Online Application - 10.04.2026
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of Online Application - <s>09.05.2026 (Up to 5:00 PM)</s> - Extended to 29.05.2026 (Up to 5:00 PM)
                                                        </b>
                                                    </li>
                                                </ul>
                                                 {/*    */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Index11 ---------------------- End  */}

                                    {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                    className={`faq-btn${activeIndex === 3 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse12`}
                                                    onClick={() =>
                                                        handleToggle(11)
                                                    }
                                                >
                                                    
                                                        <h3> Faculty Recruitment Drive 2024</h3>
                                                        <h4> Advertisement No. IITT/FACREC/01/2024 Dated January 24,2024</h4>
                                                    
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse12`}
                                            className={`collapse${activeIndex === 3 ? ' hide' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                    

                                                <b>
                                                    IIT Tirupati, an Institute of national importance declared as such under the Institute of Technology Act, 1961, invites applications from qualified Indian nationals, including Persons of Indian Origin (PIOs) and Overseas Citizens of India (OCIs) for faculty positions at the levels of Assistant Professor, Associate Professor, and Professor in the Departments and research areas as indicated below:
                                                </b>

                                               

                                                <ul className="myulcustarrow mt-3">
                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2024/Detailed_%20Advertisement-FacRec_01_2024.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">Detailed Advertisement</b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://recruitment.iittp.ac.in/"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online (Online application is closed)
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of Online Application - 24.01.2024
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of Online Application - 29.02.2024
                                                        </b>
                                                    </li>
                                                </ul>
                                                 <b className="c-link glowing-text">Interviews of Faculty Recruitment Drive 2024 (Advertisement No. IITT/FACREC/01/2024 Dated January 24,2024) for the faculty positions in various departments have been completed, and the appointment letters to the selected candidates have been sent.</b>
<br /><br />
                                            </div>
                                        </div>
                                    </div> */}
                                    
                                  
                                    
                                    
                                </div>
                                <h5>
                                    <Link
                                        to="https://files.iittp.ac.in/pdfs/general/recordretentionschedule.pdf"
                                        target="_blank"
                                    >
                                        <b className="c-link">Retention of recruitment records</b>
                                    </Link>
                                </h5>
                            </div>
                        </div>
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
